import { render, staticRenderFns } from "./WithdrawalMoney.vue?vue&type=template&id=b95386fa"
import script from "./WithdrawalMoney.vue?vue&type=script&lang=js"
export * from "./WithdrawalMoney.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalMoney.vue?vue&type=style&index=0&id=b95386fa&prod&lang=scss&module=true"
import style1 from "./WithdrawalMoney.vue?vue&type=style&index=1&id=b95386fa&prod&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports